import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComponentCloseService {
  private closeAllSubject = new Subject<string>();

  /** Emits the type of component that should close */
  closeAll$ = this.closeAllSubject.asObservable();

  /**
   * Tell all components of a given type to close.
   * Examples: "dropdown" or "menu"
   */
  close(type: string) {
    this.closeAllSubject.next(type);
  }
}
